import { Link } from "react-router-dom";
import { quickFlash } from "@/mocks/site";
import { formatHot, getCategoryName, getTopLeaks } from "@/lib/leaks";

export default function HotSection() {
  const topLeaks = getTopLeaks(5);

  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-8 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
        <div className="lg:col-span-7">
          <div className="flex items-end justify-between">
            <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              <i className="ri-fire-fill text-primary-500" />
              正在热搜
            </h2>
            <Link
              to="/feed"
              className="text-sm font-medium text-foreground-600 transition-colors hover:text-primary-600"
            >
              完整榜单
            </Link>
          </div>

          <ol className="mt-6 divide-y divide-background-200 border-y border-background-200">
            {topLeaks.map((leak, index) => (
              <li key={leak.id}>
                <Link to={`/leak/${leak.id}`} className="group flex items-center gap-4 py-4">
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                      index < 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                      {leak.title}
                    </span>
                    <span className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                      <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-800">
                        {getCategoryName(leak.category)}
                      </span>
                      <span>{leak.source}</span>
                    </span>
                  </span>
                  <span className="flex shrink-0 items-center gap-1 text-sm font-medium text-primary-600">
                    <i className="ri-fire-line" />
                    {formatHot(leak.hot)}
                  </span>
                </Link>
              </li>
            ))}
          </ol>
        </div>

        <aside className="lg:col-span-5">
          <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <div className="flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <span className="flex h-5 w-5 items-center justify-center">
                  <span className="h-2.5 w-2.5 rounded-full bg-primary-500 animate-live-dot" />
                </span>
                今日快讯滚动
              </h3>
              <span className="text-xs text-foreground-500">实时更新</span>
            </div>
            <ul className="mt-5 space-y-4">
              {quickFlash.map((item) => (
                <li key={item.id} className="flex gap-3">
                  <span className="mt-0.5 shrink-0 font-heading text-xs font-bold text-foreground-400">
                    {item.time}
                  </span>
                  <span className="text-sm leading-relaxed text-foreground-800">
                    {item.text}
                    <span className="ml-2 rounded bg-background-200 px-1.5 py-0.5 text-[11px] text-foreground-600">
                      {item.tag}
                    </span>
                  </span>
                </li>
              ))}
            </ul>
            <Link
              to="/feed"
              className="mt-6 flex items-center justify-center gap-1.5 rounded-md bg-primary-500 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              进入完整快讯流
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}